import { User } from '@core/models/user/user';
import {
    SESSION_CLEAR,
    SESSION_COMPANY_FEATURES_SET,
    SESSION_COMPANY_SET,
    SESSION_COUNTRY_SET,
    SESSION_LOCALE_SET,
    SESSION_SKILLSETS_SET,
    SESSION_USER_PERMISSIONS_SET,
    SESSION_USER_SET
  } from '../action-types';
import { ISessionState, initialSessionState } from './session-state';
import { Address } from '@core/models/common/address';
import { sortAlphabeticalByProperty } from '@core/utils/sorting';
import { Company } from '@core/models/common/company';
import { initialState } from '../session/session-state';
  
export function reducer(state: ISessionState = initialSessionState(), action: any): ISessionState {
    switch (action.type) {

        case SESSION_CLEAR:
            return { ...initialState };

        case SESSION_COMPANY_SET:
            let company: Company = Object.assign(new Company(), action.payload);
            return { ...state, company };

        case SESSION_COMPANY_FEATURES_SET:
            return { ...state, companyFeatures: action.payload };

        case SESSION_USER_SET:

            let user: User = Object.assign(new User(), action.payload);
            if (user.address) {
                user.address = Object.assign(new Address(), user.address);
            }

            if (user.companies && user.companies.length) {
                user.companies.sort(sortAlphabeticalByProperty('name'));
            }

            return {
                ...state,
                user
             };

        case SESSION_USER_PERMISSIONS_SET:
            return { ...state, permissions: action.payload };

        case SESSION_LOCALE_SET:
            return {
            ...state,
            locale: action.payload.locale
            };

        case SESSION_COUNTRY_SET:
            return { ...state, country: action.payload };
            
        case SESSION_SKILLSETS_SET:
            return { ...state, skillSets: action.payload };
        default:
            return state;
    }
}
  